import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStructureLevel = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "structure-level",
		transform: "translate(16)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12828",
				"data-name": "Path 12828",
				d: "M21,3V9",
				transform: "translate(-35 5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12829",
				"data-name": "Path 12829",
				d: "M21,3V9",
				transform: "translate(-31 5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12830",
				"data-name": "Path 12830",
				d: "M21,3V9",
				transform: "translate(-27 5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12831",
				"data-name": "Path 12831",
				d: "M21,3V9",
				transform: "translate(-23 5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12824",
				"data-name": "Path 12824",
				d: "M16,0H0V16H16Z",
				transform: "translate(-16)",
				fill: "none"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12837",
				"data-name": "Path 12837",
				d: "M13.688,9.75H16.5v2.812",
				transform: "translate(-7.72 -14.721) rotate(45)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12838",
				"data-name": "Path 12838",
				d: "M21,3v9.6",
				transform: "translate(-0.456 -17.159) rotate(90)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		]
	})
});
export default SvgStructureLevel;
